import React from 'react'
import AnimateImageTwo from './AnimateImageTwo'
import AnimateTitleTwo from './AnimatedTitleTwo'

const Ideation = () => {
  return (
    <section className="section-ideation section-padding">
      <div className="container">
        <div className="row">
          <div className="col-md-7">
            <div className="section-img-heading">
              <div className="animated-image-wrapper">
                <AnimateImageTwo />
              </div>
              <div className="section-title">
                <AnimateTitleTwo />
              </div>
            </div>
          </div>

          <div className="col-md-5">
            <div className="section-content-wrapper">
              <div className="section-paragraph">
                <p>
                  Once the brief is defined, our design team immerses itself in
                  research and brainstorming — exploring motifs, materials, and
                  moods that will define the collection. Drawing from art,
                  nature, and modern culture, we reimagine embroidery in ways
                  that are relevant, wearable, and resonant.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Ideation
